import CurrentPlanCard from "./components/CurrentPlan";

export const CurrentPlan = () => {
  // ====================== RETURN
  return <CurrentPlanCard />;
};

export default CurrentPlan;
